module.exports = __webpack_public_path__ + "static/media/scheduler_media_mpm.06a20948.xlsx";